import React from 'react';
import DatasetWorkspacesExpandable from './DatasetWorkspacesExpandable';
import DatasetOverviewChips from './DatasetOverviewChips';

const DatasetContextBar = ({ dataset, metadata, onNavigate }) => {
  const mergedDataset = { ...dataset, ...metadata };

  return (
    <DatasetWorkspacesExpandable dataset={dataset} onNavigate={onNavigate}>
      <DatasetOverviewChips dataset={mergedDataset} />
    </DatasetWorkspacesExpandable>
  );
};

export default DatasetContextBar;
